"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FetchSamlLoginRedirectUrl = exports.FetchSamlLoginRedirectUrlActionTypes = exports.SingleSignOnLoginActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var _actions = require("settings-ui-lib/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var SingleSignOnLoginActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_SAML_LOGIN_REDIRECT_URL: null
}, 'singleSignOnLogin');
exports.SingleSignOnLoginActionTypes = SingleSignOnLoginActionTypes;
var FetchSamlLoginRedirectUrlActionTypes = (0, _actions.createRequestTypes)(SingleSignOnLoginActionTypes.FETCH_SAML_LOGIN_REDIRECT_URL);
exports.FetchSamlLoginRedirectUrlActionTypes = FetchSamlLoginRedirectUrlActionTypes;
var FetchSamlLoginRedirectUrl = (0, _actions.createRequestActions)(FetchSamlLoginRedirectUrlActionTypes, {
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(FetchSamlLoginRedirectUrlActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('accountdefaults.security.singleSignOn.notifications.confirmError')));
  }
});
exports.FetchSamlLoginRedirectUrl = FetchSamlLoginRedirectUrl;